'use client';

import { useContext } from 'react';
import { PyBasicAppContext } from './PyBasicAppProvider';

export const usePyBasicApp = () => useContext(PyBasicAppContext)!;
